import { render, staticRenderFns } from "./BookingDetails.vue?vue&type=template&id=0357fa70&"
import script from "./BookingDetails.vue?vue&type=script&lang=ts&"
export * from "./BookingDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports